module.exports = __webpack_public_path__ + "static/ideaport-web-3ae851f67b72a93c3b886e56fa72a9e0.jpg";